import React, {PropsWithChildren} from "react";
import { Container } from "../../../misc/Container";
import { ShopNav } from "./ShopNav";
import {ProjectName} from "./ProjectName";
import {ProjectProvider} from "../ProjectProvider";
import {SectionHeader} from "../../../misc/SectionHeader";
import {ProjectActions} from "./ProjectActions";
import { Grid } from "@mui/material";
import {ChangesetProvider} from "./changeset/ChangesetContext";
import {ReloadContextProvider} from "./hardware/ReloadContext";
import {AlertProjectDiscontinuedProducts} from "./AlertProjectDiscontinuedProducts";

export function ShopContainer(props: PropsWithChildren<{
    actions?: JSX.Element
    name: any;
    overrideRightActions?: any;
}>) {
    return (
        <ProjectProvider>
            <AlertProjectDiscontinuedProducts />
            <ReloadContextProvider>
                <ChangesetProvider>
                    <Container topCenter={<ShopNav />}>
                        <div style={{
                            backgroundColor: "white",
                            overflow: "auto",
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                        }}>
                            <SectionHeader name={props.name}
                                noPad
                                right={<div style={{
                                    display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end", flexWrap: "nowrap", gap: 8
                                }}>
                                    {props.actions && <div><Grid container justifyContent="flex-end" alignItems="center" spacing={1} style={{flex: "unset"}}>
                                        {props.actions}
                                    </Grid></div>}
                                    {props.overrideRightActions ? props.overrideRightActions : <ProjectActions />}
                                    <div style={{
                                        borderRadius: 0,
                                        paddingTop: 4,
                                        paddingBottom: 4,
                                        paddingLeft: 12,
                                        paddingRight: 12,
                                    }}>
                                        <ProjectName />
                                    </div>
                                </div>}
                            />

                            {props.children}
                        </div>
                    </Container>
                </ChangesetProvider>
            </ReloadContextProvider>
        </ProjectProvider>
    )
}